import { multiPartData, apiPost } from '../utils/api'
import Hotjar from '@hotjar/browser'

export function uploadAssetAPI(file, endPoint, url) {
  const data = multiPartData({
    file,
    name: file.name,
  })
  Hotjar.event('upload_asset')
  return apiPost(url || `mgmt/assets/${endPoint}`, data)
}

export function uploadCsvAPI(file) {
  const data = multiPartData({
    file,
    name: file.name,
  })
  Hotjar.event('upload_csv')
  return apiPost(`master/products/import`, data)
}

export function uploadCompanyLogo(...args) {
  Hotjar.event('upload_company_logo')
  return uploadAssetAPI(...args, 'mgmt/company/logo')
}



// WEBPACK FOOTER //
// ./src/api/assets.js